// Chat is disabled on web — available on mobile app only
// Original code backed up to index.tsx.bak

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/chat/")({
	loader: () => {
		throw redirect({ to: "/download" });
	},
	component: () => null
});
